import * as R from 'ramda'
import Big from 'big.js'

export const totalCropExpense = (cropExpenseList) => {
  return R.reduce((accum, item) => {
    return accum.plus(item.calculationTotalCost)
  }, new Big(0), cropExpenseList)
}

export const totalCropIncome = (cropIncomeList) => {
  return R.reduce((accum, item) => {
    return accum.plus(item.calculationTotalPrice)
  }, new Big(0), cropIncomeList)
}

export const roundTo = (n, digits = 2) => {
  let negative = false

  if (n < 0) {
    negative = true
    n = n * -1
  }

  const multiplicator = Math.pow(10, digits)
  n = parseFloat((n * multiplicator).toFixed(11))
  n = (Math.round(n) / multiplicator).toFixed(2)
  if (negative) {
    n = (n * -1).toFixed(2)
  }
  return n
}
